import React, { Component } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { PacasAlCorteContenido } from "./components/PacasAlCorteContenido";
import "./styles/PacasAlCorte.css";

class PacasAlCorte extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        const { id, producto_id, es_conforme_bodega, fecha_corte } =
            this.props.match.params;

        const consulta = {
            tipo: "pacas",
            producto_id,
            es_conforme_bodega,
        };

        // La fila de un cierre cerrado se consulta por su cierre; la del cierre
        // en proceso, a la fecha de corte que llega en milisegundos. Si no es
        // un número se envía tal cual y el backend la rechaza
        if (id) {
            consulta.cierre_id = id;
        } else {
            const milisegundos = Number(fecha_corte);

            consulta.fecha = isNaN(milisegundos)
                ? fecha_corte
                : new Date(milisegundos).toISOString();
        }

        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "92vw", margin: "auto" }}
            >
                <CardForm
                    icon="produccion_activo"
                    titulo="Bodega producto terminado"
                    subtitulo="Pacas por pallet al corte"
                    col="12"
                >
                    <PacasAlCorteContenido
                        consulta={consulta}
                        regresar={this.regresar}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(PacasAlCorte);
